module.exports = __webpack_public_path__ + "img/32ccbe94-155c-4873-9e85-602969ecb6e4.db447ef9.webp";